import type { NavLink, SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Riffle',
    description:
        'The 2026 Library — a living deck of twenty-two objects you can scroll, spin, and open.',
    url: 'https://riffle.studio'
}

export const navLinks: NavLink[] = [
    { href: '/', label: 'Index' },
    { href: '/about', label: 'About' },
    { href: '/contact', label: 'Contact' }
]

export const contactEmail = 'hello@riffle.studio'
export const pressEmail = 'press@riffle.studio'
